import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadUserApproversRequestDTO extends PerformedByRequestDTO {
    contextCd?: string;
    roleCd?: string;
    contextProfileCd?: string;
    userEmail?: string;
    userRoleContextProfileId?: number;
}
